import * as React from "react";
import { Textarea, TextInput } from "soprasteria-ui-library";
import { IOrthodonticReferral } from "../../../../models/IOrthodonticReferral";
import { dateTimeToDateString } from "../../../../helpers/DateHelper";


interface IOrthodonticReferralTreatmentDecision {
    orthodonticReferral: IOrthodonticReferral;
}

export const OrthodonticReferralTreatmentDecision: React.FunctionComponent<IOrthodonticReferralTreatmentDecision> = ({ orthodonticReferral }) => {

    return (
        <>
            {
                orthodonticReferral.orthodonticReferralDecision ?
                    <>
                        <div className="row readonly-less-margin">
                            <h5 className="col-12">Vårdbeslut</h5>
                            <div className="col-6">
                                <TextInput name="treatmentDecisionReadonly" label="Beslut" defaultValue={orthodonticReferral.orthodonticReferralDecision} inlineLabel readonly />
                            </div>
                            {
                                orthodonticReferral.conditionCode ?
                                    <div className="col-6">
                                        <TextInput name="conditionCodeReadonly" label="Tillståndskod" defaultValue={`${orthodonticReferral.conditionCode.conditionCode} - ${orthodonticReferral.conditionCode.diagnosis}`} inlineLabel readonly />
                                    </div>
                                    :
                                    <div className="col-6">
                                        <TextInput name="treatmentNotNeededReasonReadonly" label="Anledning" defaultValue={orthodonticReferral.orthodonticReferralTreatmentNotNeededReason} inlineLabel readonly />
                                    </div>
                            }
                            <div className="col-6">
                                <Textarea rows={6} name="orthodonticReferralDecisionMotivationReadonly" label="Beslutsmotivering" defaultValue={orthodonticReferral.orthodonticReferralDecisionMotivation} inlineLabel readonly />
                            </div>
                            <div className="col-6">
                                <TextInput name="orthodonticReferralDecisionValidToReadonly" label="Giltig t.o.m." defaultValue={dateTimeToDateString(orthodonticReferral.validUntilDate)} inlineLabel readonly />
                            </div>
                        </div>
                        <hr />
                    </>
                    : null
            }
        </>
    );
}